export default {
  list: [],
  total: 0,
  selected: [],
  customers: {},
  invoices: {},
  tableOptions: {
    groupBy: [],
    groupDesc: [],
    itemsPerPage: 25,
    multiSort: false,
    mustSort: false,
    page: 1,
    sortBy: ['date'],
    sortDesc: [true],
  },
};
